export function FourOOne({ customMessage }: { customMessage?: string }) {
  return (
    <>
      <h2>ERROR 401</h2>
      <h1>Access Denied</h1>
      {customMessage && <p>{customMessage}</p>}
    </>
  );
}
